module.exports = __webpack_public_path__ + "aq.no2.65594e19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/aq.no2.jpg
// module id = WMoK
// module chunks = 0